import { SearchInput, Tooltip } from '@mm/components';
import { useDebounce, useResolutionInfo } from '@mm/hooks';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import styles from './SearchContacts.module.css';
import { MOBILE_SMALL } from '../../../../../../../constants/screenSize';

type Props = {
  value?: string;
  className?: string;
  onSearch: (value: string) => void;
};

export const SearchContacts = ({ value, className, onSearch }: Props) => {
  const [contactsSearchValue, setContactsSearchValue] = useState('');
  const [isMounted, setIsMounted] = useState(false);

  const { screenWidth } = useResolutionInfo();
  const isMobile = screenWidth <= MOBILE_SMALL;

  const currentValue = value;

  const debouncedSearch = useDebounce(contactsSearchValue.trim(), 500);

  const onSearchContacts = () => {
    onSearch?.(debouncedSearch);
  };
  const disabled = false;

  useEffect(() => {
    if (isMounted) {
      onSearchContacts();
    }
    setIsMounted(true);
  }, [debouncedSearch]);

  useEffect(() => {
    if (!currentValue) {
      setContactsSearchValue('');
    }
  }, [currentValue]);

  return (
    <Tooltip
      title="Search by Phone, Full Name, Email, LinkedIn URL, Company domain"
      placement={isMobile ? 'bottom' : 'right'}
    >
      <>
        <SearchInput
          css={{ container: classNames(styles.searchInput, className) }}
          placeholder="Phone, Full Name, Email, LinkedIn URL, Company domain"
          value={contactsSearchValue}
          onChange={event => setContactsSearchValue(event.target.value)}
          onSearch={onSearchContacts}
          disabled={disabled}
          maxLength={100}
        />
      </>
    </Tooltip>
  );
};
